import React from 'react';

/**
 * Intentional empty state — a quiet card instead of a bare "No data" string.
 * Use `hint` for the "what would make this non-empty" line.
 */
export function EmptyState({
  title,
  hint,
  action,
  compact = false,
}: {
  title: string;
  hint?: string;
  action?: React.ReactNode;
  compact?: boolean;
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-lg border border-dashed border-border/90 text-center ${
        compact ? 'px-4 py-6' : 'px-6 py-12'
      }`}
    >
      <span className="mb-3 grid h-8 w-8 place-items-center rounded-full border border-border bg-surface">
        <span className="h-1.5 w-1.5 rounded-full bg-mutedDim" />
      </span>
      <div className="text-[13px] font-medium text-textPrimary">{title}</div>
      {hint ? <div className="mt-1 max-w-xs text-[12px] leading-relaxed text-mutedDim">{hint}</div> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
